(() => {
  if (window.solsticeCollectionColorReady) return;
  window.solsticeCollectionColorReady = true;
  window.publishColorSwitch = color => {
    if (!['gold', 'silver'].includes(color)) return;
    window.SolsticePersonalization?.setColor(color);
    const capsule = document.querySelector('.color-capsule-filter');
    const destination = capsule?.dataset[`${color}Url`];
    if (destination) {
      const url = new URL(destination, window.location.origin);
      if (url.pathname !== window.location.pathname) {
        // Preserve sorting and unrelated filters, but not the previous finish or page.
        url.search = window.location.search;
        url.searchParams.delete('page');
        for (const key of [...url.searchParams.keys()]) {
          if (key.startsWith('filter.v.option.') && /color|colour|couleur|finition|finish/i.test(key)) {
            url.searchParams.delete(key);
          }
        }
        window.location.assign(url.href);
        return;
      }
    }
    window.dispatchEvent(new CustomEvent('global-color-switch', { detail: { color } }));
  };
})();
